export default "__VITE_ASSET__6b636032__"